import React from "react";
import { useNavigate } from "react-router-dom";
import { PenLine } from "lucide-react";

export default function DraftsHeader({ count }) {
  const navigate = useNavigate();

  return (
    <div className="flex items-start sm:items-center justify-between flex-wrap gap-4 mb-6">
      <div>
        <h1 className="font-extrabold text-3xl sm:text-4xl text-[#7209B7] underline decoration-[3px] underline-offset-8 mb-2">
          {count} Drafts
        </h1>
        <p className="text-slate-500 text-sm sm:text-base">
          Manage all your draft blog posts
        </p>
      </div>

      <button
        type="button"
        onClick={() => navigate("/dashboard/create-blog")}
        className="inline-flex items-center gap-2 bg-[#7209B7] text-white font-semibold text-sm px-6 py-3 rounded-full hover:bg-[#5a07a0] active:scale-95 transition-all duration-200"
      >
        <PenLine className="w-4 h-4" />
        Write New Blog
      </button>
    </div>
  );
}
